import type { ReactNode } from 'react';
import { cx } from './cx';

export type TagColour = 'grey' | 'blue' | 'turquoise' | 'purple' | 'green' | 'yellow' | 'red' | 'inactive';

/** govuk/components/tag. Colours follow GOV.UK Frontend tag colours (≥ 4.5:1); the text always carries the meaning. */
export function Tag({ colour, className, children }: { colour?: TagColour; className?: string; children: ReactNode }) {
  return (
    <strong className={cx('govuk-tag', colour === 'inactive' ? 'govuk-tag--inactive' : colour && `app-tag--${colour}`, className)}>
      {children}
    </strong>
  );
}
